import script from "./FeaturesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&setup=true&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=8766caae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8766caae"]])

export default __exports__